import React from "react";
import AboutImg from "../../assets/images/home-page/about-02.jpg";
import "../../assets/css/home-page/about.css";

export default function About() {
  return (
    <section id="about" className="about-section">
      <div className="container-fluid grid-about-split">
        <div className="about-visual-canvas animate-on-scroll">
          <div className="industrial-blueprint-box">
            <img src={AboutImg} alt="About Us" className="industrial-blueprint-img" />
            <div className="blueprint-overlay-metric">
              <span className="metric-large">M40</span>
              <span className="metric-sub">Maximum Mix Strength</span>
            </div>
          </div>
        </div>

        <div className="about-narrative-block animate-on-scroll">
          <span className="editorial-tag">Manufacturing Process & Quality Control</span>
          <h3>Decades of Excellence in High-Density Concrete Casting</h3>
          <p className="narrative-para">
            Our manufacturing facilities utilize high-speed **Centrifugal Spinning Equipment** and modern **Vertical Vibration Casting Technology** to produce concrete profiles free of structural voids and honeycombing.
          </p>
          <p className="narrative-para">
            By carefully regulating water-cement hydration ratios and sourcing premium, clean crushed granite aggregates (graded 10mm to 20mm), our pipes achieve a dense, impermeable structure. This provides long-term resistance to sulfate attacks and high-velocity water abrasion.
          </p>
          
          <div className="factory-benchmarks-list">
            <div className="benchmark-item">
              <strong>High-Tensile Wire Caging:</strong> Pre-welded structural steel meshes offer superior structural integrity against sudden shifts in earth pressure.
            </div>
            <div className="benchmark-item">
              <strong>Controlled Steam Curing:</strong> Uniform curing profiles ensure rapid, reliable compressive strength development before site delivery.
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}